<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="609" @click:outside="closeModal">
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold"
                >Import Animal</v-toolbar-title
              >

              <v-spacer></v-spacer>

              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <form autocomplete="off">
              <v-card-text class="black--text">
                <div class="form">
                  <div v-if="!file">
                    <div
                      :class="['dropZone', dragging ? 'dropZone-over' : '']"
                      @dragenter="dragging = true"
                      @dragleave="dragging = false"
                    >
                      <div class="dropZone-info" @drag="onChange">
                        <span class="fa fa-cloud-upload dropZone-title"></span>
                        <span class="dropZone-title">
                          <v-icon x-large color="primary"
                            >mdi-tray-arrow-up</v-icon
                          >
                        </span>
                        <div class="d-flex-start">
                          <div class="primary--text">Browse</div>
                        </div>
                        <div class="dropZone-upload-limit-info">
                          <div>or drop your (CSV, XLS, XLSx) file here</div>
                        </div>
                      </div>
                      <input type="file" accept=".csv" @change="onChange" />
                    </div>
                    <span class="red--text">{{ fileError }}</span>
                  </div>
                  <div v-else class="dropZone-uploaded">
                    <div class="dropZone-uploaded-info">
                      <v-btn
                        class="ma-2 white--text"
                        @click="removeFile"
                        color="primary"
                        outlined
                      >
                        Remove File
                        <v-icon right dark> mdi-trash-can </v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div v-if="file" class="uploadedFile-info">
                    <div>{{ file.name }}</div>
                  </div>
                </div>

                <v-card-actions class="mt-10">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="ma-2"
                    outlined
                    color="primary"
                    @click="closeModal"
                    width="112"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    :disabled="!file"
                    width="112"
                    color="primary"
                    class="btn-11 btn-22"
                    @click="uploadFile"
                  >
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import AnimalService from "@/_services/AnimalService";
export default {
  computed: {
    dialog: {
      get() {
        return this.dialogI;
      },
      set() {
        return this.dialogI;
      },
    },
  },
  data() {
    return {
      file: "",
      fileError: "",
      dragging: false,
    };
  },
  methods: {
    closeModal(success = false) {
      this.removeFile();
      this.$emit("closeUploadAnimal", success);
    },
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.createFile(files[0]);
    },
    createFile(file) {
      console.log(file.type);
      // if (!file.type.match('text/csv')) {
      //     this.fileError = 'Only CSV file is allowed.'
      //     this.dragging = false;
      //     return;
      // }

      // if (file.size > 5000000) {
      //     alert('please check file size no over 5 MB.')
      //     this.dragging = false;
      //     return;
      // }

      this.file = file;
      console.log(this.file);
      this.dragging = false;
    },
    removeFile() {
      this.file = "";
    },

    uploadFile() {
      this.startLoading();
      let formData = new FormData();
      formData.append("animal", this.file);
      AnimalService.uploadAnimals(formData)
        .then(resp => {
          this.stopLoading();
          if (resp.success) {
            this.closeModal(true);
          }
        })
        .catch(err => {
          this.stopLoading();
          console.log(err);
        });
    },
  },

  props: ["dialogI"],
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
.dropZone {
  width: 100%;
  height: 150px;
  position: relative;
  border: 2px dashed #97a8b8;
}

.dropZone:hover {
  border: 2px solid $primary-color;
}

.dropZone:hover .dropZone-title {
  color: $primary-color;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 150px;
  position: relative;
  border: 2px solid $primary-color;
  // border-radius: 10px;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
</style>
